import BaseTable from './DefaultTable'
import { TableImperativeHandle, ExtendedDefaultTableProps } from './interface'

export { type TableImperativeHandle, type ExtendedDefaultTableProps }
export default BaseTable
